import type { ImageDto } from "$src/core/models/dto";
import pickImageUrl from "$src/core/utils/image/pick-image-url";

/** Colour logo when active, greyscale when idle; either falls back to the other. */
const getEpgChannelLogoUri = ({
  logo,
  logoDark,
  isActive,
}: {
  logo?: ImageDto;
  logoDark?: ImageDto;
  isActive: boolean;
}): string | undefined => {
  const image = isActive ? (logo ?? logoDark) : (logoDark ?? logo);

  return image
    ? pickImageUrl(image, ["landscape", "square", "portrait"])
    : undefined;
};

export default getEpgChannelLogoUri;
